﻿//@ts-nocheck
class YandexMap {
    constructor(id: string, state = {}, settings = {}) {
        ymaps.ready(() => {
            const globalId = `${id}Map`;
            this.id = id;
            this.state = {
                center: [56.75584199999999, 60.61596],
                zoom: 8,
                controls: [],

                ...state
            };
            this.settings = settings;

            window[globalId]?.destroy();

            this.map = window[globalId] = new ymaps.Map(this.id, this.state, {
                yandexMapDisablePoiInteractivity: true
            });

            if (settings.type === 'one-placemark') {
                if (state.center) {
                    this.updatePlacemark(state.center, settings.pointAddress);
                }

                if (settings.mapClickable) {
                    this.map.events.add('click', (e) => {
                        this.updatePlacemark(e.get('coords'));
                    });
                }
            }
        });
    }

    getNewPlacemark(coords) {
        const properties = {
            iconCaption: 'поиск...'
        };

        const options = {
            preset: 'islands#redDotIcon',
            draggable: true
        };

        return new ymaps.Placemark(coords, properties, options);
    }

    updatePlacemark(coords, text) {
        const updateInfoPlacemark = coords => {
            const properties = this.placemark.properties;

            if (text) {
                properties.set({ iconCaption: text });
            }
            else {
                properties.set('iconCaption', 'поиск...');
                if (this.settings.onUpdatePlacemarkAfter) {
                    this.settings.onUpdatePlacemarkAfter();
                }

                window.BackPlacesService.getObjectByCoordinates(coords, ({ fullAddress }) => {
                    properties.set({ iconCaption: fullAddress });

                    if (this.settings.onUpdatePlacemarkBefore) {
                        this.settings.onUpdatePlacemarkBefore();
                    }
                });
            }
        };

        if (this.placemark) {
            this.placemark.geometry.setCoordinates(coords);
        }
        else {
            this.placemark = this.getNewPlacemark(coords);
            this.map.geoObjects.add(this.placemark);
            this.placemark.events.add('dragend', () => updateInfoPlacemark(this.placemark.geometry.getCoordinates()));
        }

        updateInfoPlacemark(coords, text);
    }

    setZoom(newZoom) {
        this.map.setZoom(newZoom);
    }

    setCenter(coords) {
        this.map.setCenter(coords);
    }

    setRoute(coords, callback) {
        this.removeGeoObjects();

        YandexMap.route(coords, routes => {
            this.map.geoObjects.add(routes);

            if (callback) {
                callback(routes);
            }
        });
    }

    removeGeoObjects() {
        ymaps.ready(() => {
            this.map.geoObjects.removeAll();
        });
    }

    addComboboxSelectHandler(combobox) {
        combobox.bind('select', autocomplete => {
            const { value, text } = autocomplete.dataItem;

            window.BackPlacesService.getObjectByPlaceId(value, ({ coords }) => {
                this.setZoom(16);
                this.setCenter(coords);
                this.updatePlacemark(coords, text);
            });
        });
    }

    setClusterer(geoOptionsArray) {
        this.removeGeoObjects();

        const geoObjects = [];

        geoOptionsArray.forEach(({ coords, title, description }) => {
            geoObjects.push(new ymaps.GeoObject({
                geometry: {
                    type: 'Point',
                    coordinates: coords
                },
                properties: {
                    clusterCaption: title,
                    balloonContentBody: description
                }
            }));
        });

        const clusterer = new ymaps.Clusterer({ clusterDisableClickZoom: true });
        clusterer.add(geoObjects);

        this.map.geoObjects.add(clusterer);
    }

    static removeNonBreakingSpaces(text) {
        return text.replaceAll('&#160;', '');
    }

    static route(coords, callback) {
        ymaps.route(coords.map(point => ({ type: 'wayPoint', point })), {
            mapStateAutoApply: true,
            zoomMargin: 20
        }).done(routes => callback(routes), err => {
            throw err;
        }, this);
    }

    static getIntermediatePoints(route, step = 700) {
        let routeLength = route.getLength();
        const segments = [];
        route.getPaths().toArray().forEach(path => segments.push(...path.getSegments()));

        function getIntermediatePoint(distance) {
            let segmentIndex = 0,
                segmentLength = segments[segmentIndex].getLength();

            while (distance > segmentLength) {
                distance -= segmentLength;
                segmentIndex++;
                segmentLength = segments[segmentIndex].getLength();
            }

            const coordinates = segments[segmentIndex].getCoordinates(),
                segmentRatio = distance / segmentLength,
                indexOnSegment = Math.floor(segmentRatio * (coordinates.length - 1));

            const [latitude, longitude] = coordinates[indexOnSegment];
            return { latitude, longitude };
        }

        const intermediatePoints = [];

        for (let distance = step; distance < routeLength; distance += step) {
            intermediatePoints.push(getIntermediatePoint(distance));
        }

        return intermediatePoints;
    }
}

window.YandexMap = YandexMap;